import { render, staticRenderFns } from "./star-display.vue?vue&type=template&id=5df4deeb&"
import script from "./star-display.vue?vue&type=script&lang=js&"
export * from "./star-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df4deeb')) {
      api.createRecord('5df4deeb', component.options)
    } else {
      api.reload('5df4deeb', component.options)
    }
    module.hot.accept("./star-display.vue?vue&type=template&id=5df4deeb&", function () {
      api.rerender('5df4deeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wvzD47c4x4si/JS/comp/star-display.vue"
export default component.exports